






import { Vue, Component } from 'vue-property-decorator';

@Component({
  name: 'PaymentLogos',
})
export default class PaymentLogos extends Vue {
}
